const AppleIcon = ({ size = 24 }) => {
  return (
    <img
      src={require("../../../assets/images/apple.svg").default}
      alt="apple"
      width={size}
    />
  );
};

export default AppleIcon;
